import React, { useEffect, useState,useRef,useMemo   } from "react";
import ISGraph from "../components/graph/ISGraph";
import BaseGraph from "../components/graph/BaseGraph";
import BaseGraph1 from "../components/graph/BaseGraph1";
import BaseGraph2 from "../components/graph/BaseGraph2";
import PiezoGraph from "../components/graph/PiezoGraph";
import TimeSeriesChart from "../components/graph/TimeSeriesChart";
import MultiSensorChart from "../components/graph/MultiSensorChart";
import { formatSensorKeyLabel } from "../utils/sensorLabel";
// import Doc from '../components/doc';
// import ExportData from "../components/ExportData";
// import axios from "axios";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import {fetchDashboard,bydashboard,telemetrydata,feachDocument,graphData,timeSeries,downloadDocx} from '../services/api'
// import { Document, Packer, Paragraph, TextRun, Header, Footer, ImageRun,  SectionType,AlignmentType, Table, TableRow, TableCell, WidthType  } from "docx";
// import { saveAs } from "file-saver";
// import html2canvas from "html2canvas";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import jsPDF from "jspdf";
// import { FaBeer } from "react-icons/fa";
import { FaAngleDown ,FaAngleUp,FaEyeSlash} from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
// import DocumentViewer from "../components/DocumentViewer";
// import ReactDocViewer from "react-doc-viewer";
// import ReportDropdown from "../components/ReportDropdown";                       
import { toast } from 'react-toastify';
import { pdfExport } from '../utils/pdfExport';
import { docxExport } from '../utils/docxExport';
import { displayDeviceName, withoutAliasedOriginals } from '../utils/deviceAlias';
import { withoutHiddenSensors } from '../utils/hiddenSensors';
import Select from 'react-select';
import ProcessingModal from '../components/ProcessingModal';
const Report = () => {


 
 
  const selectStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,  
      textTransform: 'capitalize',
      backgroundColor: state.isFocused ? '#f7fafc' : 'white',
      color: 'black',
            cursor:'pointer',
            border:'none', boxShadow: 'none',   '&:hover': {
              border: 'none',
                  backgroundColor:'#f7fafc'
            }
    }),
    control: (provided) => ({
      ...provided,
      padding: 5,
      borderRadius: '5px',
      borderColor: '#ccc',
      backgroundColor:'#f7fafc',
      border:'none',
      boxShadow: 'none', 
      '&:hover': {
        border: 'none',
    
      },
      cursor:'pointer',
    
      textTransform: 'capitalize',
    }),
   

  };


  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [isDisabled, setIsDisabled] = useState(true);
  const[loading,setLoading]=useState(false);
  const[loadingDoc,setloadingDoc]=useState(false);
  const [devices, setDevices] = useState([]);
  // Device ab multi-select hai: hamesha chuni hui device id ka array. Pehle ye
  // ek scalar tha jisme 'All' ek sentinel value thi; ab "sab chune hue" ka
  // matlab hai ki array me saari visible id maujood hain (neeche allSelected).
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [telemetryData, setTelemetryData] = useState(null);
  const [data, setData] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [test,setTest]=useState([]);
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [deviceOpen, setDeviceOpen] = useState(false);
  const [dashboardSelectedText, setDashboardSelectedText] = useState('');
  const [DashboardSelectedID, setDashboardSelectedID] = useState('');
  const [deviceSelectedText, setDeviceSelectedText] = useState('');
  const [chartData, setChartData] = useState({});
  const [loadingDocType, setLoadingDocType] = useState(null);
  const [exportStatus, setExportStatus] = useState("");
  const [documents, setDocuments] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [previewContent, setPreviewContent] = useState(false);
  const [deviceProfile,setdeviceProfile]=useState();
  const [deviceProfileOpen, setDeviceProfileOpen] = useState(false);
  const [loadingsubmit,setloadingsubmit]=useState(false);
  // `loading` is owned by the preview toggle and is unrelated to fetching, so
  // the dropdowns get their own flags tied to the requests they depend on.
  const [loadingDashboards,setLoadingDashboards]=useState(true);
  const [loadingDevices,setLoadingDevices]=useState(false);
  // Live counter while an export runs, plus how long the finished one took.
  const [exportElapsed,setExportElapsed]=useState(0);
  const [exportDuration,setExportDuration]=useState(null);
  const exportTimerRef = useRef(null);
  // Set when the user cancels, so the result of an in-flight export is ignored.
  const exportCancelledRef = useRef(false);
  const exportAbortRef = useRef(null);
  const [exportPercent,setExportPercent]=useState(0);
  const [exportStage,setExportStage]=useState("");

  // Nothing should keep ticking if the page is left mid-export.
  useEffect(() => () => clearInterval(exportTimerRef.current), []);
  // Tables are off by default; they are opted into per export.
  const [withTable,setwithTable]=useState(false);
  const [withGraph,setwithGraph]=useState(true);
 

    useEffect(() => {
      const fetchInitialData = async () => {
        try {
          const [documentsRes, dashboardRes] = await Promise.all([
            feachDocument(),
            fetchDashboard(),
          ]);
          // console.log(dashboardRes.data);
          setDocuments(documentsRes.data);
          setDashboardData(dashboardRes.data);
        } catch (err) {
          console.error("Fetch error:", err);
        } finally {
          setLoadingDashboards(false);
        }
      };
    
      fetchInitialData();
    }, []);

    
    useEffect(() => {
      setIsDisabled(!(DashboardSelectedID && selectedDevice.length && deviceProfile));
    }, [DashboardSelectedID, selectedDevice,deviceProfile]);
    
    const CustomOption = (props) => {
      const { data, innerRef, innerProps } = props;
      return (
        <div ref={innerRef} {...innerProps} style={{ padding: '10px', backgroundColor: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center',cursor:'pointer' }}>
          {data ? (
            <>
              <span  onClick={() => deviceByDashboard(data.value)}>{data.label}</span>
         
            </>
          ) : (
            <OptionSkeleton />
          )}
        </div>
      );
    };
 

    const formattedMOnthDate = (date)=>{
     return  date.toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        // day: "2-digit",
        // hour: "numeric",
        // minute: "2-digit",
        // hour12: true,
      });

    }


 
    const options = [
 
      ...(dashboardData || []).map(device => ({
        value: device.customer_id,
        label: device.title
      }))
    ];

const uniqueProfiles = Array.from(
  new Map(
    (devices || []).map(({ device_profile }) => {
      let profile = device_profile;

      if (profile?.startsWith("piezo")) {
        profile = "piezo";
      } else if (profile?.startsWith("IS")) {
        profile = "IS";
      }

      return profile ? [profile, { id: profile, name: profile }] : null;
    }).filter(Boolean)
  ).values()
);


const profileOptions = uniqueProfiles.length > 0
  ? uniqueProfiles.map((profile) => ({
      value: profile.id,
      label: profile.name
    }))
  : [{ value: '', label: 'No profiles found', isDisabled: true }];

 
const finalOptions = uniqueProfiles.length > 0
  ? [{ value: 'All', label: 'All' }, ...profileOptions]
  : profileOptions;  

 

// withoutAliasedOriginals purana INC-WP-42 / INC-WP-45 list se hata deta hai
// (jab unka rebase version maujood ho), taaki user ko har device ek hi baar
// dikhe. Naam displayDeviceName se aata hai, jo "rebase" suffix hata deta hai.
const filteredDevices = withoutAliasedOriginals(devices).filter(row =>
  deviceProfile === 'All' || deviceProfile === '' || row.device_profile?.startsWith(deviceProfile)
);

const deviceOptions = filteredDevices
  .slice()
  .map(row => ({ value: row.id, label: displayDeviceName(row.name) }))
  .sort((a, b) => a.label.localeCompare(b.label));

// react-select ko chuni hui values option-object ke roop me chahiye.
const selectedDeviceOptions = deviceOptions.filter(opt => selectedDevice.includes(opt.value));
const allDevicesSelected =
  deviceOptions.length > 0 && selectedDeviceOptions.length === deviceOptions.length;

// "All Devices" ek asli option nahi, sirf select-all toggle hai — isliye iski
// value ek sentinel hai jo kabhi state me nahi jaati (handleDeviceChange use
// wahin expand kar deta hai).
const ALL_DEVICES = '__all__';
const options2 = deviceOptions.length > 0
  ? [{ value: ALL_DEVICES, label: 'All Devices' }, ...deviceOptions]
  : [{ value: '', label: 'No devices found', isDisabled: true }];

const handleDeviceChange = (chosen) => {
  const picked = chosen || [];
  const toggledAll = picked.some(opt => opt.value === ALL_DEVICES);
  if (toggledAll) {
    // "All Devices" pe click: agar pehle se sab chune hue the to sab hatao,
    // warna saare visible device chun lo.
    setSelectedDevice(allDevicesSelected ? [] : deviceOptions.map(opt => opt.value));
    return;
  }
  setSelectedDevice(picked.map(opt => opt.value));
};

// Checkbox wala option row. Dashboard select ka CustomOption alag hai — wo
// click pe device fetch karta hai, isliye usse reuse nahi kiya ja sakta.
const DeviceOption = (props) => {
  const { data, isSelected, innerRef, innerProps } = props;
  const checked = data.value === ALL_DEVICES ? allDevicesSelected : isSelected;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', cursor: 'pointer' }}
    >
      {/* readOnly: click parent div handle karta hai, warna React warn karta hai */}
      <input type="checkbox" checked={checked} readOnly style={{ cursor: 'pointer' }} />
      <span>{data.label}</span>
    </div>
  );
};
 
    const formattedStartDate = (startDate)=>{ 
       const date = new Date(startDate);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
      // const hours = date.getHours() % 12 || 12;
      // const minutes = String(date.getMinutes()).padStart(2, '0');
      // const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
    
      return `${month}/${day}/${year}`;
  }
  const formattedEndDate = (endDate)=>{ 
    const date = new Date(endDate);
   const day = String(date.getDate()).padStart(2, '0');
   const month = String(date.getMonth() + 1).padStart(2, '0'); 
   const year = date.getFullYear();
   // const hours = date.getHours() % 12 || 12;
   // const minutes = String(date.getMinutes()).padStart(2, '0');
   // const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
 
   return `${month}/${day}/${year}`;
}

 

    const documentContent = (title) => {
      const formattedStartDate = startDate.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    
      const formattedEndDate = endDate.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    
   
      const modifiedDocuments = documents
        .filter((row) => row.title === title)
        .map((item) => {
          const modifiedContent = item.content
            .replace(/{startDate}/g, formattedStartDate)
            .replace(/{endDate}/g, formattedEndDate)
            .replace(/<\/?[^>]+(>|$)/g, ""); 
          return modifiedContent;
        });
    

      return modifiedDocuments[0];  
    };
    
// console.log(documentContent('header'));
   const FooterContent=()=>{
    if (documents && documents[1].content) {
      return documents[1].content
        .replace(/{startDate}/g, startDate)
        .replace(/{endDate}/g, endDate)
        .replace(/<\/?[^>]+(>|$)/g, "");
    }
    return "";
    
   }

    const toggleDropdown = (name) => {
      const stateSetters = {
        dashboard: setDashboardOpen,
        device: setDeviceOpen,
        'device-profile': setDeviceProfileOpen,
      };
    
      Object.entries(stateSetters).forEach(([key, setter]) => {
        setter(key === name ? (prev) => !prev : false);
      });
    };

    const deviceByDashboard = async (DashboardSelectedID) => {
      // console.log(DashboardSelectedID);
      setDashboardSelectedID(DashboardSelectedID);
      setdeviceProfile('');
      // Nayi dashboard ki device list aa rahi hai — purani chuni hui id ab
      // is list me hain hi nahi, isliye selection saaf kar do.
      setSelectedDevice([]);
      setLoadingDevices(true);
      // console.log(deviceProfile);
      // setDevices('');
      try {
        const res = await bydashboard(DashboardSelectedID);
        // console.log('res.data');
        // console.log(res.data);
        setDevices(res.data);
      } catch (err) {
        console.error("Device fetch error:", err);
      } finally {
        setLoadingDevices(false);
      }
    };

    const humanTime = (time) => {
      const date = new Date(Number(time));  
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    };

    const handleSelect = (type, text, value) => {
      const actions = {
        dashboard: () => {
          setDashboardSelectedText(text);
          setDashboardSelectedID(value);
          deviceByDashboard(value);
          setDashboardOpen(false);
          setdeviceProfile('');
        },
        device: () => {
          setDeviceSelectedText(text);
          setSelectedDevice(Array.isArray(value) ? value : [value]);
          setDeviceOpen(false);
        },
        'device-profile': () => {
          setdeviceProfile(text);
          setDeviceProfileOpen(false);
        }
      };
    
      if (actions[type]) {
        actions[type]();
      } else {
        console.warn(`Unknown handleSelect type: ${type}`);
      }
    };
    
 

    const handleButtonSubmit = async () => {
      // console.log('test');
      setloadingsubmit(true);
      setChartData({});
    
      try {
        const fetchData = async (deviceId, profile) => {
          const fetchFunction = profile.startsWith('IS') ? telemetrydata : timeSeries;
 
          const res = await fetchFunction(deviceId, startDate.getTime(), endDate.getTime());
          return res.data;
        };
        // console.log('selectedDevice');
    // console.log(device.device_profile.startsWith(selectedDevice));
        // Ek hi path chuni hui 1..n device ke liye. Pehle yahan do branch the
        // ('All' vs ek device); ab selection hamesha array hai, isliye alag
        // single-device branch ki zaroorat nahi.
        const chosen = withoutAliasedOriginals(devices).filter(device =>
          selectedDevice.includes(device.id)
        );
        const fetchPromises = chosen.map(async (device) => {
          const data = await fetchData(device.id, device.device_profile);
          return { device, data };
        });

const results = await Promise.all(fetchPromises);

// Jis device ka data nahi aaya use bhi rakha jaata hai — graph khaali aayega
// par aayega. Pehle yahan aise device filter ho jaate the aur report me unka
// naam tak nahi dikhta tha.
//
// name/profile API response se lete hain, aur na mile to devices list se —
// khaali response me ye fields hoti hi nahi, par chart choose karne aur
// heading chhapne ke liye dono chahiye.
const normalized = results.map(({ device, data }) => ({
  id: device.id,
  data: {
    device_name: data?.device_name ?? device.name,
    device_profile: data?.device_profile ?? device.device_profile,
    // Field se hataye gaye sensor yahin nikal jaate hain, taaki screen, DOCX
    // aur PDF sabko already-filtered data mile.
    data: withoutHiddenSensors(device.name, Array.isArray(data?.data) ? data.data : []),
  },
}));

// Display naam se sort, warna "INC-WP-42-Rebaseline" apne base naam ki jagah
// list me kahin aur chala jaata.
const sortedResults = normalized.sort((a, b) => {
  const nameA = displayDeviceName(a.data.device_name ?? "");
  const nameB = displayDeviceName(b.data.device_name ?? "");
  return nameA.localeCompare(nameB);
});

 
const dataMap = sortedResults.reduce((acc, { id, data }) => {
  acc[id] = data;
  return acc;
}, {});

setChartData(dataMap);
      } catch (err) {
        console.error('API Error:', err);
      } finally {
        setloadingsubmit(false);
      }
    };
    

 
  const exportRef = useRef();

  const handleExport = (type) => async () => {

    const startedAt = Date.now();
    exportCancelledRef.current = false;
    exportAbortRef.current = new AbortController();
    setExportDuration(null);
    setExportElapsed(0);
    setExportPercent(0);
    setExportStage("Starting");
    clearInterval(exportTimerRef.current);
    exportTimerRef.current = setInterval(() => {
      setExportElapsed((Date.now() - startedAt) / 1000);
    }, 100);

     setLoadingDocType(type);
    // console.log(type);
    // // setLoadingDocType(type);   

    // console.log(deviceProfile);
    // console.log(selectedDevice);
    // console.log(groupDataForCharts);
    // console.log(devices);
    //      console.log(chartData);
    // return
    try {
      // console.log(chartData);
      // console.log(deviceProfile);
      // console.log(groupDataForCharts);


      switch (type) {
        case 'docx': 
         await docxExport({
            startDate,
            endDate,
            chartData,
            deviceProfile,
            groupDataForCharts,
            humanTime,withGraph,withTable,
            onProgress: ({ percent, stage }) => {
              setExportPercent(percent);
              setExportStage(stage);
            },
            signal: exportAbortRef.current.signal
          })
          break;
          case 'pdf':
            // devices/documents pehle pass hi nahi hote the, isliye pdfExport
            // apni pehli line par hi (documents.find) crash kar jaata tha.
            await pdfExport({
              devices,
              documents,
              startDate,
              endDate,
              chartData,
              deviceProfile,
              groupDataForCharts,
              humanTime,withGraph,withTable
            })

            break;
      
        default:
          break;
      }
    } catch (error) {
      if (error?.name !== "AbortError") {
        console.error("Export failed:", error);
      }
    } finally {
      clearInterval(exportTimerRef.current);

      if (exportCancelledRef.current) {
        // The user already dismissed this run; don't report a time for it.
        setLoadingDocType(null);
      } else {
        // Recorded here rather than inside the timeout below, so the reported
        // figure is the actual export work and not the 1s cosmetic hold.
        setExportDuration((Date.now() - startedAt) / 1000);
        setTimeout(() => {
          setLoadingDocType(null);
        }, 1000);
      }
    }
  };

  const handleCancelExport = () => {
    exportCancelledRef.current = true;
    // Signals docxExport to stop at its next checkpoint, before saveAs runs.
    exportAbortRef.current?.abort();
    clearInterval(exportTimerRef.current);
    setLoadingDocType(null);
    setExportDuration(null);
    setExportPercent(0);
    setExportStage("");
    setExportStatus("");
  };

  const formatDuration = (seconds) => {
    if (seconds === null || Number.isNaN(seconds)) return "";
    if (seconds < 60) return `${seconds.toFixed(1)}s`;
    const mins = Math.floor(seconds / 60);
    return `${mins}m ${(seconds - mins * 60).toFixed(1)}s`;
  };
  
  const deviceProfileGet = (deviceID) => {
    const row = devices.find((row) => row.id == deviceID);
    if (row) {
 
      return row.device_profile;
    }
    return null;  
  }

  
 


  const exportPreview = async () => {
    setLoading(true);
    // setloadingDoc(true);
    setShowPreview(prev => !prev);

  setTimeout(() => {
    setLoading(false);
  }, 1000);
  

  };
  

  const renderChart = (profile, id, data) => {
    // console.log(data);
    if (!data || data.length === 0) return <>Not Found</>;

  // console.log('profile');
  // console.log(profile);

    switch (profile) {
       case 'IS6':
        return <BaseGraph data={data} deviceId={id} height={500} position="left" />;
       case 'IS19':
        return <BaseGraph data={data} deviceId={id} height={500} position="left" />;
      case 'IS':
        return <ISGraph data={data} deviceId={id} height={500} position="left" />;
      case 'piezo1':
        return <TimeSeriesChart deviceId={id} data={data} />;
      default:
        return <>Unsupported Chart</>;
    }
  };
  const renderChart1 = (profile, name, data) => {
 
    // if (!data || data.length === 0) return <>Not Found</>;
  console.log('profile');
  console.log(profile);
  // console.log(data.length*10);
  // console.log(data);
 if(profile=='IS19' || profile=='IS8')
 {
      return <BaseGraph data={data} alarm={0.70} action={1.0} maximum={1.60} deviceName={name} height={data.length * 7} position="bottom" />;
 }

  if(profile=='IS20' || profile=='IS2' || profile=='IS3' || profile=='IS4')
 {
      return <BaseGraph data={data} alarm={0.50} action={0.7} maximum={1.0} deviceName={name} height={data.length * 7} position="bottom" />;
 }

  if(profile=='IS41' || profile=='IS42' || profile=='IS39' || profile=='IS40' || profile=='IS35' || profile=='IS36' || profile=='IS37' || profile=='IS38' || profile=='IS51' || profile=='IS52' || profile=='IS47' || profile=='IS48' || profile=='IS43' || profile=='IS44' || profile=='IS49' || profile=='IS50' || profile=='IS45' || profile=='IS46' || profile=='IS53' || profile=='IS54' )
 {
      return <BaseGraph data={data} alarm={0.50} action={0.70} maximum={0.95} deviceName={name} height={data.length * 7} position="bottom" />;
 }

  if(profile=='IS11' || profile=='IS6' || profile=='IS5')
 {
      return <BaseGraph data={data} alarm={0.30} action={0.40} maximum={0.65} deviceName={name} height={data.length * 7} position="bottom" />;
 }

  if(profile=='IS9' || profile=='IS1' || profile=='IS7' || profile=='IS10')
 {
      return <BaseGraph data={data} alarm={0.65} action={0.90} maximum={1.40} deviceName={name} height={data.length * 7} position="bottom" />;
 }

   if(profile=='IS16' || profile=='IS17' || profile=='IS12' || profile=='IS14' || profile=='IS13' || profile=='IS15' || profile=='IS21' || profile=='IS22' || profile=='IS23' || profile=='IS24')
 {
      return <BaseGraph1 data={data} alarm={0.80} action={1.10} maximum={1.70} deviceName={name} height={data.length * 7} position="bottom" />;
 }

   if(profile=='IS30' || profile=='IS29' || profile=='IS26' || profile=='IS27' || profile=='IS25' || profile=='IS28'  || profile=='IS34' || profile=='IS33' || profile=='IS32' || profile=='IS31')
 {
      return <BaseGraph2 data={data} alarm={1.00} action={1.40} maximum={2.10} deviceName={name} height={data.length * 7} position="bottom" />;
 
 }
  



console.log('profileprofile');
console.log(profile);

  if (profile.startsWith('IS')) {
    return <ISGraph data={data} deviceName={name} height={data.length * 7} position="bottom" />;
  } else if (profile.startsWith('piezo') || profile.startsWith('sg')) {
    return <TimeSeriesChart deviceName={name} data={data} />;
  } else if ( profile.startsWith('Sensor'))
  {
    return <MultiSensorChart deviceName={name} data={data} />;
  }
   else {
    return <>Unsupported Chart</>;
  }

 
  };

  const groupDataForCharts = (data) => {
    const keyGroup = {};

    data.forEach((item) => {
      const timestamp = Number(item.ts);
      const value = Number(item.value);
      let keyname = item.key;
      const lastChar = keyname.charAt(keyname.length - 1);
      
      if (!isNaN(lastChar)) {
        keyname = keyname.slice(0, -1);  
      }

      if (!keyGroup[keyname]) {
        keyGroup[keyname] = {  type: [],data:[]}
      }

      let existingRow = keyGroup[keyname].data.find(row => row.date === item.ts);

if (existingRow) {
 
  existingRow[item.key] = item.value;
} else {
 
  keyGroup[keyname].data.push({
    date: item.ts,
    [item.key]: item.value
  });
}


      const alreadyExists = keyGroup[keyname].type.some(t => t.type === item.key);
      // console.log(item.key);
      // console.log(item);
      if (!alreadyExists && !isNaN(item.value)) { 
        // console.log('item.value');
        // console.log(item.value);
        keyGroup[keyname].type.push({ type: item.key });
      }
    });  

    return keyGroup;
  };
 
  const TableData = (data, device) => {
    if (device.startsWith('IS')) {
      return (
        <>
          {data &&
            Object.entries(data).map(([key, value], index) => (
              <div key={index}>
                <div className="overflow-x-auto mt-3 mb-3">
                  <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                    <tbody className="text-gray-700 text-center">
                      {value.map((row, rowIndex) =>
                        row[1] ? (
                          <tr key={rowIndex} className="hover:bg-gray-50 border">
                            <td className="px-6 py-4 whitespace-nowrap border">
                              {row[2]} key
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap border">
                              {parseFloat(row[1]).toFixed(2)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap border">
                              {humanTime(row[0])}
                            </td>
                          </tr>
                        ) : null
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
        </>
      );
    } else if (device.startsWith('piezo') || device.startsWith('sg')) {
      const rows = groupDataForCharts(data);
      return (
        <table className="min-w-full bg-white border border-gray-200 rounded-lg font-14">
          <tbody className="text-gray-700 text-center">
            {Object.entries(rows).map(([groupName, groupRows], groupIndex) => (
              <React.Fragment key={groupIndex}>
                <tr className="bg-gray-50">
                  <td
                    colSpan="6"
                    className="px-1 py-3 text-center text-sm font-medium uppercase tracking-wider"
                  >
                    {groupName.replace(/_/g,' ')}
                  </td>
                </tr>
  
                <tr className="hover:bg-gray-50 border">
                  <td className="px-1 py-4 whitespace-nowrap border">Date</td>
                  {/* {console.log(groupRows)} */}
                  {groupRows?.type?.map((row, rowIndex) => (
                    <td
                      key={rowIndex}
                      className="px-1 py-4 whitespace-nowrap border"
                    >
                      {row.type.slice(-2)}
                    </td>
                  ))}
                </tr>
  
                {groupRows?.data?.map((row, rowIndex) => (
                  <tr key={rowIndex} className="hover:bg-gray-50 border">
                    <td className="px-1 py-4 whitespace-nowrap border">
                      {humanTime(row.date)}
                    </td>
                    {groupRows.type.map((col, colIndex) => (
                      <td
                        key={colIndex}
                        className="px-1 py-4 whitespace-nowrap border"
                      >
                        {row[col.type] !== undefined ? row[col.type] : '-'}
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      );
    } else if (device.startsWith('Sensor')) {
      const rows = groupDataForCharts(data);
      return (
        <table className="min-w-full bg-white border border-gray-200 rounded-lg font-14">
          <tbody className="text-gray-700 text-center">
            {Object.entries(rows).map(([groupName, groupRows], groupIndex) => {
             
 if (groupName === 'Alarm Level' || groupName === 'Action Level' || groupName === 'Maximum Level') {
    return null;
  }
              return (
              <React.Fragment key={groupIndex} >
                <tr className="bg-gray-50">
                  <td
                    colSpan="6"
                    className="px-1 py-3 text-center text-sm font-medium uppercase tracking-wider"
                  >
                    {formatSensorKeyLabel(groupName).replace(/_/g,' ')}

                  </td>
                </tr>
  
                <tr className="hover:bg-gray-50 border">
                  <td className="px-1 py-4 whitespace-nowrap border">Date</td>
                  {/* {console.log(groupRows)} */}
                  {groupRows?.type?.map((row, rowIndex) => (
                    <td
                      key={rowIndex}
                      className="px-1 py-4 whitespace-nowrap border"
                    >
                      Value
                    </td>
                  ))}
                </tr>
  
                {groupRows?.data?.map((row, rowIndex) => (
                  <tr key={rowIndex} className="hover:bg-gray-50 border">
                    <td className="px-1 py-4 whitespace-nowrap border">
                      {humanTime(row.date)}
                    </td>
                    {groupRows.type.map((col, colIndex) => (
                      <td
                        key={colIndex}
                        className="px-1 py-4 whitespace-nowrap border"
                      >
                        {row[col.type] !== undefined ? row[col.type] : '-'}
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
              )
    })}
          </tbody>
        </table>
      );
    } 
    else {
      return <div>Device type not supported.</div>;
    }
  };
  
  // Memoised so the export progress timer (which re-renders this component
  // ~10x/sec) cannot force every chart to redraw. Same tree, same output.
  const chartTree = useMemo(() => (
<>
{Object.keys(chartData).length ? (
  <>
    {Object.entries(chartData).filter(
    ([deviceId]) =>
      deviceId !== "22a68aa0-2ce8-11f0-b7ab-6d119f1d4014"
  ).map(([deviceId, deviceData]) => (
      // data-device-id se export graph ko id se dhoondta hai. Pehle wo
      // position (index) se uthta tha, jo tabhi sahi tha jab har device
      // theek ek .graph render kare — "Unsupported Chart" wala device ya
      // koi bhi order ka farak saare graph shift kar deta tha.
      <div key={deviceId} data-device-id={deviceId}>
        <h3>Device: {displayDeviceName(deviceData.device_name) || "Unknown"}</h3>
{/* {console.log(deviceData.device_profile)} */}
        {console.log(deviceData.data)} 
        {deviceData.data ? (
         <>
            {renderChart1(deviceData.device_profile,displayDeviceName(deviceData.device_name), deviceData.data)}

            </>
       
        ) : (
          <p>No data</p>
        )}
      </div>
    ))}
  </>
) : (
  <p>No data found</p>
)}
</>
  ), [chartData]);

  return (
 
<div>
{/* The two columns were w-[32%] + w-[70%], which overflows to 102% and
    never stacks. A fixed-width control rail beside a fluid preview keeps
    the preview intact while letting the page reflow on smaller screens. */}
<div className="flex flex-col gap-6 xl:flex-row xl:items-start">
<section className="w-full xl:w-[360px] xl:shrink-0">
                <div className="flex w-full flex-col rounded-lg border border-bgray-200 bg-white p-5 dark:border-darkblack-400 dark:bg-darkblack-600">
                <div className="w-full">

                <p className="mt-3 mb-2 text-base font-bold text-bgray-900 dark:text-white">Dashboard</p>

<Select  isSearchable={false}  
        options={options}
        styles={selectStyles}
        placeholder={loadingDashboards ? "Loading dashboards..." : "Select a Dashboard"}
        components={{ Option: CustomOption }}
        isLoading={loadingDashboards}
        isDisabled={loadingDashboards}
      />
  <p className="mt-3 mb-2 text-base font-bold text-bgray-900 dark:text-white">Device Profile</p>
<Select 
 
// value={deviceProfile?'':deviceProfile}
 isSearchable={false}
        options={finalOptions}
        styles={selectStyles}
        placeholder={loadingDevices ? "Loading profiles..." : "Select a profile"}
        isLoading={loadingDevices}
        isDisabled={loadingDevices}
        onChange={(selectedOption) => setdeviceProfile(selectedOption?.value)}
      />
        <p className="mt-3 mb-2 text-base font-bold text-bgray-900 dark:text-white">Device</p>

<Select  isSearchable={false}
        isMulti
        // Checkbox list ki tarah bartav: menu khula rahe aur chuna hua option
        // list me bhi dikhta rahe (warna tick lagane ke baad wo gayab ho jaata).
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        isClearable={false}
        components={{ Option: DeviceOption }}
        options={options2}
        value={selectedDeviceOptions}
        styles={selectStyles}
        placeholder={loadingDevices ? "Loading devices..." : "Select devices"}
        isLoading={loadingDevices}
        isDisabled={loadingDevices}
        onChange={handleDeviceChange}
      />


 

 
      <p className="mt-3 mb-2 text-base font-bold leading-[24px] text-bgray-900 dark:text-white">Start Timestamp</p>

      <div className="w-full">
      <DatePicker
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        showTimeSelect
        dateFormat="Pp"
        timeFormat="HH:mm"
        timeIntervals={15}
        className="w-full"
        timeCaption="Time"
        showIcon
        maxDate={endDate}
        // The calendar plus its floated 85px time column needs ~317px. Anchored
        // normally it inherits this 320px rail as its containing block and the
        // time column drops out of the popup, so it is positioned against the
        // viewport instead.
        popperProps={{ strategy: "fixed" }}
        popperPlacement="bottom-start"
      />
      </div>
 



      <p className="mt-3 mb-2 text-base font-bold leading-[24px] text-bgray-900 dark:text-white">End Timestamp</p>
      {/* The fixed h-[56px] here used to clip the field. */}
      <div className="w-full">
      <DatePicker
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        showTimeSelect
        dateFormat="Pp"
        timeFormat="HH:mm"
        timeIntervals={15}
        className="w-full"
        timeCaption="Time"
        showIcon
        minDate={startDate}
        popperProps={{ strategy: "fixed" }}
        popperPlacement="bottom-start"
      />
      </div>
      {/* end */}




                        </div>
 
 
 
 

 
<button
className="mt-5 flex w-full items-center justify-center gap-2 rounded-lg bg-success-300 px-6 py-2.5 text-base font-semibold text-white transition-colors
           hover:bg-success-400
           disabled:cursor-not-allowed disabled:bg-bgray-300 disabled:text-bgray-600"
disabled={isDisabled}
onClick={handleButtonSubmit}
>
{loadingsubmit && (
    <svg
      className="animate-spin h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
  )}
  {loadingsubmit ? "Loading..." : "Submit"}
</button>
 


  {/* Export PDF Button */}

 {/* {console.log(loadingDoc)} */}

<div className="mt-6 flex items-center justify-between border-t border-bgray-200 pt-5 dark:border-darkblack-400">
<div className="text-base font-bold leading-[24px] text-bgray-900 dark:text-white">Export Format</div>

<button
  type="button"
  onClick={()=>exportPreview()}
  aria-label={showPreview ? "Hide preview" : "Show preview"}
  className="rounded-lg p-2 text-bgray-600 transition-colors hover:bg-bgray-100 dark:text-bgray-50 dark:hover:bg-darkblack-500"
>{showPreview?<FaEyeSlash />:<FaEye />}</button>
</div>

 
{/* const [withTable,setwithTable]=useState(true);
const [withGraph,setwithGraph]=useState(true); */}
{
  // console.log(withGraph)
}

<div className="mb-3 flex items-center justify-between">

  <div className="text-sm font-medium text-bgray-700 dark:text-bgray-50">With Graph</div>
  <div>
  <button onClick={()=>setwithGraph(prev=>!prev)} type="button" className={`switch-btn relative inline-flex h-5 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent text-center transition-colors
duration-200 ease-in-out focus:outline-none ${withGraph?'active':''}`} role="switch" aria-checked={withGraph} aria-label="Include graphs in the export">
 <span aria-hidden="true" className="pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
</button>

  </div>
</div>

<div className="mb-4 flex items-center justify-between">

  <div className="text-sm font-medium text-bgray-700 dark:text-bgray-50">With Table</div>
  <div>
  <button onClick={()=>setwithTable(prev=>!prev)} type="button" className={`switch-btn relative inline-flex h-5 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent text-center transition-colors
duration-200 ease-in-out focus:outline-none ${withTable?'active':''}`} role="switch" aria-checked={withTable} aria-label="Include tables in the export">
 <span aria-hidden="true" className="pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
</button>
  </div>
</div>





<div className="flex flex-wrap gap-2 justify-center transition duration-300 ease-in-out">
  
 


  {['docx'].map((type) => (
    <button
      key={type}
      className="btn-1 flex w-full items-center justify-center gap-2 rounded-lg bg-success-300 px-4 py-2.5 text-sm font-semibold text-white transition-colors
                hover:bg-success-400
                disabled:cursor-not-allowed disabled:bg-bgray-300 disabled:text-bgray-600"
      // disabled={isDisabled}
      onClick={() => handleExport(type)()}
    >
      {loadingDocType === type ? (
        <>
          <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"> <circle
              className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"
            /> <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"/>
          </svg>
          Exporting... {formatDuration(exportElapsed)}
        </>
      ) : (
        `Export ${type.toUpperCase()}`
      )}
    </button>
  ))}
</div>
{exportStatus && (
  <p className="text-sm text-blue-500 mt-2 text-center">{exportStatus}</p>
)}
{exportDuration !== null && !loadingDocType && (
  <p className="mt-2 text-center text-sm font-medium text-bgray-600 dark:text-bgray-50">
    Processed in {formatDuration(exportDuration)}
  </p>
)}

          </div>
          </section>

<ProcessingModal
  open={!!loadingDocType}
  title={`Generating ${String(loadingDocType || '').toUpperCase()} report`}
  detail={exportStage || "Please keep this tab open until the file is ready."}
  percent={exportPercent}
  elapsed={formatDuration(exportElapsed)}
  onCancel={handleCancelExport}
/>

<section className="w-full min-w-0 flex-1">
 <div className="mb-[48px] flex w-full flex-col justify-between rounded-lg bg-white p-4 dark:bg-darkblack-600 lg:px-8 lg:py-7 pbreack">
 
 

 
 {showPreview?(<>  
      <div className="header font-bold mb-6 document_preview">
  <h1 className="text-center">VTA's BART Silicon Valley Phase II Project <br></br> (CP2 - EWP 3C)</h1>
  <h2 className="underline text-center mt-3">Instrumentation & Monitoring Report - {formattedMOnthDate(startDate)}</h2>
  <br></br>
  <div className="text-center my-5">
  <img className="m-auto" src="/doc/picture1.png"/>
  </div>

  <h2 className="text-center mt-3">{formattedMOnthDate(startDate)}</h2>

  <div className="mt-5 flex justify-between"> 
<div className="">  <h2 className="text-left my-3">Submitted by:</h2>
  <img className="" width="150" src="/doc/picture2.png"/>
  </div>
<div></div>
<div className="text-right">  <h2 className="text-right my-3">Submitted by:</h2>
 KSTJV <br></br>
De La Cruz Blvd., 300,<br></br>
Santa Clara, CA 95050
  </div>
  </div>
 
<br></br>
<br></br>
<img className="" width="100%" height="" src="/doc/picture3.png"/>
<br></br><br></br>
<hr></hr>
<br></br><br></br>

<img className="text-right ml-auto" width="80" src="/doc/picture5.png"/>

<h2 className="italic underline text-center font-normal">Geotechnical & Structural Engineering/Instrumentation, Environmental Mitigation & Control 
	</h2>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<div>
  <div className="font-normal mb-3">{formattedStartDate(startDate)} - {formattedEndDate(endDate)}</div>
  <div>KSTJV</div>
  <div>De La Cruz Blvd., 300,</div>
  <div>Santa Clara, CA 95050</div>
  <div className="mt-3">Attention: Bryce Grimm</div>
  <div>Re: BART Silicon Valley Phase II; CP2 - EWP 3C Geotechnical Instrumentation Report.</div>
  <div className="mt-3">Dear Bryce:</div>
  <div className="font-normal mt-2">This Letter transmits our Geotech Instrumentation Report for BART Silicon Valley Phase II; CP2 - EWP 3C Geotechnical Instrumentation Report.</div>
  <div className="mt-5">Please call with any questions.</div>
  <br></br>
  <br></br>
  <div className="text-center font-normal">Best regards,</div>
  <div className="text-center font-normal">Analysis & Solutions Consultants (ASC)</div>
  <div className="text-center m-auto"><img className="m-auto my-3" width="120" height="" src="/doc/picture4.png"/></div>

  <div className="text-center font-normal">Dots Oyenuga, Ph.D., P.E.</div>
  <div className="text-center font-normal">Principal-in-charge</div>
</div>
<br></br>
<br></br>
<hr></hr>
<br></br>
<br></br>
<div>
  <div className="font-normal mb-3">{formattedStartDate(startDate)} - {formattedEndDate(endDate)}</div>
  <div>Introduction</div>
  <div className="font-normal">April�s Report presents piezometer baseline data obtained for Early Works Package 3C, from April 24th to April 30th, 2025. The piezometers are highlighted in the drawings below; the piezometer baseline period  will last for one month, until the end of May, 2025. Baseline monitoring for inclinometers is expected to  begin mid-May of 2025 and will also be featured in May�s Report</div>
   <div className="text-center m-auto"><img className="m-auto my-3" width="100%" height="" src="/doc/picture7.png"/></div>
 <br>
 </br>
 <div className="text-center m-auto"><img className="m-auto my-3" width="100%" height="" src="/doc/picture6.png"/></div>

</div>
<br></br>
<br></br>
<hr></hr>
<br></br>
<br></br>
</div> 
 </>):''}
  <div ref={exportRef} className={`chart-wrapper`}>

{chartTree}
 


  </div>
  {showPreview?(<>  
  <br></br>
    <hr></hr>
      <div className="mt-4 flex justify-between">
  <div> 150 Executive Park Blvd., Ste. <br></br> 3600 San Francisco, CA 94134</div>
  <div className="text-center">Page No <br></br> <span class="flex"><img width={16} height={12} src="/doc/picture10.png"/> : www.ascengineering.org</span>  </div>
  <div><span class="flex"><img width={16} src="/doc/picture8.png"/> : (510) 207-1387</span> <span class="flex"><img width={16} src="/doc/picture9.png"/> : (510) 291 9733</span></div>  
   </div>
    
 </>):''}  
  </div>
</section>
  </div>
    </div>
  );
};

export default Report;
